<div class="main-wrapper">
    <div class="wrapper dashboard-wrapper">
      <div class="my-container">
          <div class="status-widget-container">
            <div class="error-container plain page-level mt-5 pt-5">
              <img src="assets/images/new-set/409.svg" alt="" class="big-thumbnail">
              <h4 class="error-title">Conflict (Resource conflict)</h4>
              <p class="error-subtitle">Your session is invalid due to login on another device.</p>
              <p class="error-subtitle"><a (click)="logout()" style="display: inline !important; color: blue;">Click here</a> to re-login</p>
            </div>
        </div>
      </div>
    </div>
  </div>